var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "new_home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navbar-new",
    transform: "translate(-31.000000, -125.000000)",
    fill: "#418AFE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new_home",
    transform: "translate(31.307729, 125.140149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1660487,5.8800362 L8.46027091,0.250406573 C8.06230418,-0.0834688578 7.47868209,-0.0834688578 7.08071536,0.250406573 L0.374937579,5.8800362 C0.0419334322,6.16080796 -0.0840600635,6.61433263 0.0571048608,7.02410303 C0.198269785,7.43387344 0.577968556,7.7167988 1.01493758,7.73781398 L1.01493758,13.3674436 C1.01493758,13.9504108 1.49250051,14.4229992 2.08160425,14.4229992 L13.459382,14.4229992 C14.0484858,14.4229992 14.5260487,13.9504108 14.5260487,13.3674436 L14.5260487,7.7413325 C14.9630177,7.72031732 15.3427165,7.43739196 15.4838814,7.02762155 C15.6250463,6.61785115 15.4990528,6.16432647 15.1660487,5.88355472 L15.1660487,5.8800362 Z M7.41493758,13.3709621 L6.70382647,13.3709621 L6.70382647,10.2042955 L8.8371598,10.2042955 L8.8371598,13.3709621 L7.41493758,13.3709621 Z M13.459382,6.68577694 L13.459382,13.3709621 L9.90382647,13.3709621 L9.90382647,10.2042955 C9.90382647,9.62132823 9.42626353,9.14873991 8.8371598,9.14873991 L6.70382647,9.14873991 C6.11472273,9.14873991 5.6371598,9.62132823 5.6371598,10.2042955 L5.6371598,13.3709621 L2.08160425,13.3709621 L2.08160425,6.68577694 L1.06471536,6.68577694 L7.77049313,1.05614731 L14.4762709,6.68577694 L13.459382,6.68577694 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSvg);
export default __webpack_public_path__ + "static/media/Home_svg.5a373895208309cb75f14a3f25867117.svg";
export { ForwardRef as ReactComponent };